import { Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { IconSvg } from 'shared/icon';
import { FieldAccess } from 'app/layout/types/header';
import { StyledListItemHeader } from 'app/layout/components/Layout.styled';
import SearchFields from './SearchFields';

export interface SearchProps {
  fieldAccesses: FieldAccess;
}

const Search = ({ fieldAccesses }: SearchProps) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  const { colors } = useTheme();

  const handleSearch = () => setVisible(true);

  const onClose = () => setVisible(false);

  const handleHotKeys = useCallback((e: KeyboardEvent) => {
    // Ctrl + Q
    if (e.ctrlKey && e.key.toLowerCase() === 'q') {
      handleSearch();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleHotKeys);
    return () => {
      document.removeEventListener('keydown', handleHotKeys);
    };
  }, [handleHotKeys]);

  return (
    <>
      {visible && <SearchFields visible={visible} changeModalState={onClose} fieldAccesses={fieldAccesses} />}
      <StyledListItemHeader onClick={handleSearch}>
        <Tooltip placement="bottom" title={t('quickSearch')}>
          <div>
            <IconSvg icon="SearchIcon" width="1.25rem" height="1.29rem" color={colors.white} />
          </div>
        </Tooltip>
      </StyledListItemHeader>
    </>
  );
};

export default Search;
